import React from 'react';
import PropTypes from 'prop-types';
import Heading from '@cotyorg/ccx-atoms/Heading';
import BBCodeParser from '@cotyorg/ccx-utils/js/components/BBCodeParser';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';

const ProductSteps = ({ length, stepsHeading, steps }) => (
  <>
    {length > 0 && (
      <div className="product-steps">
        <Heading level={2} extraClass="product-steps__heading">
          {stepsHeading}
        </Heading>

        {Array.isArray(steps) &&
          steps.map(({ heading, description }) => (
            <div key={uuid()}>
              <strong>{heading}: </strong>
              <BBCodeParser>{description}</BBCodeParser>
            </div>
          ))}
      </div>
    )}
  </>
);

ProductSteps.propTypes = {
  length: PropTypes.number,
  stepsHeading: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.object),
};

export default ProductSteps;
